<template>
  <div class="lookPdf">
    <div class="addBox">
      <el-select
        v-model="fcqyjgdm"
        placeholder="请选择"
        @change="changeName"
        style="width: 400px"
      >
        <el-option
          v-for="item in options"
          :key="item.fcqyjgdm"
          :label="item.fcqymc"
          :value="item.fcqyjgdm"
        >
        </el-option>
      </el-select>
    </div>
    <div class="pdfBox">
      <div>
        <el-tree
          :data="data"
          :props="defaultProps"
          default-expand-all
          @node-click="changePdf"
          highlight-current
          :expand-on-click-node="false"
          ref="tree"
        >
        </el-tree>
        <div class="pdfIframe">
          <iframe
            :src="src"
            frameborder="0"
            class="pdfIframe"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      show: "", // 是否代理
      fcqyjgdm: "",
      options: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "tbwjmc",
      },
      src: "",
      wjlx: "",
    };
  },
  computed: {
    enterprise() {
      return this.options.find((e) => e.id === this.value) || {};
    },
  },
  created() {
    if (this.$route.query?.flag == 1) {
      this.show = true;
    } else {
      this.show = false;
    }
    this.getList();
  },
  methods: {
    async getList() {
      try {
        const res = await this.$api.zbwjtbdw();
        if(res.status == 200){
          this.options = res.data.data.tbdwList;
          this.fcqyjgdm = this.options[0]?.fcqyjgdm;
          this.data = res.data.data.cgkbxmtbwjzcList;
          if(this.data[0]?.children){
            if (res.data[0]?.children.length > 0) {
              this.wjlx = this.data[0].children[0].wjlx;
            } else {
              this.wjlx = this.data[0].wjlx;
            }
          }else{
            this.wjlx = this.data[0].wjlx;
          }
          if(this.fcqyjgdm)this.changePdf();
        }
      } catch (err) {
        this.waitLoading = false;
        console.log("debug", err);
      }
    },
    changeName() {
      this.changePdf();
    },
    async changePdf(data) {
      if (data) {
        if(data.children){
          if (data.children?.length) return;
        }else{
          this.wjlx = data.wjlx;
        }
      }
      let para = {
        orgCodes: this.fcqyjgdm,
        fileNo: this.wjlx,
      };
      console.log(para)
      try {
        const res = await this.$api.cktbwj(para);
        const blob = new Blob([res.data], { type: "application/pdf;chartset=UTF-8" });
        //this.src='./pdf/web/viewer.html?file='+window.URL.createObjectURL(blob)
        if('msSaveOrOpenBlob' in navigator){
          this.src='./pdf/web/viewer.html?file='+window.URL.createObjectURL(blob)
        }else{
          this.src = window.URL.createObjectURL(blob);
        }
      } catch (err) {
        this.waitLoading = false;
        console.log("debug", err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lookPdf {
  background: #f6f6f6;
  height: 100vh;
  width: 100%;
}
.addBox {
  background: #fff;
  padding: 10px 50px;
}
.pdfBox {
  height: calc(100vh - 80px);
  padding: 20px;
  margin: 10px 20px 0;
  background: #fff;
  border: 1px solid #dddddd;
  > div {
    height: calc(100% - 30px);
    display: flex;
    .el-tree {
      width: 280px;
      margin-right: 10px;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #dddddd;
      padding-left: 10px;
    }
    .pdfIframe {
      flex: 1;
    }
  }
  .title {
    font-size: 14px;
    color: #333333;
    padding-bottom: 10px;
  }
}
::v-deep {
  .el-tree-node__content {
    font-weight: bold;
    color: #333;
  }
  .el-tree-node__children .el-tree-node__content {
    font-weight: normal;
    color: #999999;
  }
}
.tag{
  float: left;
  width: 40px;
  height:16px;
  line-height: 16px;
  border-radius: 2px;
  background:#d8d8d8;
  text-align: center;
  color:#666;
  font-size: 12px;
  position: relative;
  top:9px;
  font-weight: 400;
  margin-left:10px;
}
</style>